export const dateFilters = [
  'dueDate',
  'startDate',
  'completedDate',
  'createdDate',
];
export const templateRestrictedValues = [
  'dueDate',
  'startDate',
  'completedAt',
  'createdDate',
];
export const formatFilters = (filters) => {
  const formattedFilters = filters?.filters?.map((filter) => {
    if (dateFilters.includes(filter.filterName)) {
      if (!filter.value.from && !filter.value.to) {
        return {
          ...filter,
          value: [null, null],
        };
      } else {
        const fromDate = filter?.value?.from ?? null;
        const toDate =
          !filter?.value?.to && fromDate ? fromDate : filter?.value?.to;
        return {
          ...filter,
          value: !fromDate && !toDate ? null : [fromDate, toDate],
        };
      }
    }
    return filter;
  });
  return { ...filters, filters: formattedFilters || null };
};
